import { DEFAULT_NAVIGATION_SETTING, Navigation } from './navigation';
import StickyNavigation from './sticky-navigation';
import SubNavigation from './sub-navigation';
import Table from './table';
import { Slider } from '@parship/psg-slider';

new Navigation(DEFAULT_NAVIGATION_SETTING);
new StickyNavigation();
new Table();

document
	.querySelectorAll('.current-menu-item .psg-slider, .current-menu-parent .psg-slider')
	.forEach((item: HTMLElement) => {
		new SubNavigation(item);
	});

document.querySelectorAll('.studies-slider, .psg-slider').forEach((item: HTMLElement) => {
	new Slider({ target: item, itemsPerView: 1, loop: true });
});
